@if (visible) {
  <div>
    @if (!auth.logged && backgroundDisable) {
      <div class="backgroundDisable"></div>
    }
    @if (!auth.logged && showLoginDiv) {
      <div class="login center-block">
        <h3>{{ 'igo.auth.connection' | translate }}</h3>
        @if (options.google && options.google.enabled !== false) {
          <igo-auth-google (login)="onLogin()" />
        }
        @if (options.microsoft && options.microsoft.enabled !== false) {
          <igo-auth-microsoft (login)="onLogin()" />
        }
        @if (options.microsoftb2c && options.microsoftb2c.enabled !== false) {
          <igo-auth-microsoftb2c (login)="onLogin()" />
        }
        @if (options.facebook && options.facebook.enabled !== false) {
          <igo-auth-facebook (login)="onLogin()" />
        }
        @if (!options.intern || options.intern.enabled !== false) {
          <igo-auth-intern
            [allowAnonymous]="options.allowAnonymous"
            (login)="onLogin()"
          />
        }
      </div>
    }
    @if (auth.logged && showAlreadyConnectedDiv) {
      <div class="login center-block">
        <p>{{ 'igo.auth.welcome' | translate: user }}</p>
        <button matButton="elevated" type="button" (click)="logout()">
          {{ 'igo.auth.signOut' | translate }}
        </button>
      </div>
    }
    @if (showLogoutDiv) {
      <div class="login center-block">
        <p>{{ 'igo.auth.deconnection' | translate }}</p>
        @if (options.homeRoute) {
          <button matButton="elevated" type="button" (click)="home()">
            {{ 'igo.auth.home' | translate }}
          </button>
        }
      </div>
    }
  </div>
}
